export default __webpack_public_path__ + "static/media/1.bb562925.gif";